<template>
    <div :id="deliveryId" class="popup order__map order__popup js-map-popup">
        <div class="order__popup-header order__subtitle cart__subtitle">
            Укажите детали доставки
            <i class="popup__close arcticmodal-close" @click="close()"></i>
        </div>
        <div class="order__img">
            <div ref="map" style="width: 100%; height: 500px;" class="map-distance"></div>

            <div class="order__loc">
                <div class="order__city">
                    <span v-if="address.country">{{ address.country }}</span>
                    <span v-if="address.city">, {{ address.city }}</span>
                </div>
                <div class="order__addr">
                    <span v-if="address.street">{{ address.street }}</span>
                    <span v-if="address.building">, {{ address.building }}</span>
                </div>
                <div class="input">
                    <label :for="'office-modal-' + deliveryId"
                           class="input__label input__label--compact">Офис</label>
                    <input :id="'office-modal-' + deliveryId"
                           class="input__field input__field--compact"
                           type="text"
                           v-model="office"
                           placeholder="Номер офиса">
                </div>
                <button @click="confirm" class="button button--md">Подтвердить</button>
            </div>
        </div>
    </div>
</template>

<script>
/* global ymaps */ //https://yandex.ru/dev/maps/jsbox/2.1/event_reverse_geocode/

export default {
    name: "YMapComponent",
    data() {
        return {
            office: '',
            address: {
                fullAddress: '',
                country: '',
                city: '',
                street: '',
                building: '',
            },
            defaultCoords: {
                lat: '55.75396',
                lon: '37.620393'
            },
        }
    },
    props: {
        deliveryId: {
            type: String,
        },
        coords: {},
        confirmedAddress: {
            type: Function,
        },
    },
    methods: {
        confirm() {
            this.confirmedAddress(this.deliveryId, this.address.fullAddress, this.office)
            this.close();
        },
        close() {
            this.$emit('close');
        },
        changeAddress() {
            this.$emit('changeAddress');
        },
        getAddress(coords) {
            let self = this;

            ymaps.geocode(coords).then(function (res) {
                var firstGeoObject = res.geoObjects.get(0);

                self.address.fullAddress = firstGeoObject.getAddressLine();
                self.address.country = firstGeoObject.getCountry();
                self.address.city = firstGeoObject.getLocalities()[0];
                self.address.street = firstGeoObject.getThoroughfare();
                self.address.building = firstGeoObject.getPremiseNumber();
            });
        }
    },
    mounted() {
        let self = this;
        let coords = self.coords

        if (!self.coords[0] || !self.coords[1]) {
            self.coords[0]  = self.defaultCoords.lat
            self.coords[1]  = self.defaultCoords.lon
        }

        ymaps.ready(() => {
            const map = new ymaps.Map(this.$refs.map, {
                center: self.coords,
                zoom: 15,
                controls: []
            }, {
                searchControlProvider: 'yandex#search'
            });

            map.controls.add(new ymaps.control.ZoomControl({options: { position: { right: 10, top: 50 }}}));

            const placemark = new ymaps.Placemark(this.coords, {});

            map.geoObjects.add(placemark);

            map.events.add('click', function (e) {
                coords = e.get('coords');

                placemark.geometry.setCoordinates(coords);

                self.getAddress(coords, placemark)
            });
            self.getAddress(self.coords, placemark)
        });
    },
}
</script>

<style>
.map-box {
    width: 100%;
    height: 600px;
}
</style>